import { BaseStore } from 'fluxible/addons';
import Immutable from 'immutable';

class BriefBookTypeStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.selectedBookType = '';
        this.bookTypes = new Immutable.OrderedSet([]);
    }

    load(payload) {
        if (payload.book_types) {
            this.bookTypes = new Immutable.OrderedSet(payload.book_types);
        }

        if (payload.body.book_type) {
            this.selectedBookType = payload.body.book_type;
        }

        this.emitChange();
    }

    selectBookType(bookType) {
        if (this.selectedBookType !== bookType) {
            this.selectedBookType = bookType;
        }

        this.emitChange();
    }

    isStepComplete() {
        return this.selectedBookType.length > 0;
    }
}

BriefBookTypeStore.storeName = 'BriefBookTypeStore';
BriefBookTypeStore.handlers = {
    SELECT_BOOK_TYPE: 'selectBookType',
    LOAD_DRAFT_DATA: 'load',
};

export default BriefBookTypeStore;



// WEBPACK FOOTER //
// ./js/launch/stores/BriefBookTypeStore.js